/**
 * @typedef {Object} GumDO
 * @property {number} stageNumber - The stage number
 * @property {string} toothGumType - The type of tooth gum (UPPER or LOWER)
 * @property {string} fileUrl - URL of the tooth file
 * @property {string} fileType - Type/extension of the file
 * @property {string} filePath - Full file path
 */

import { cloneDeep } from "lodash";
import { TOOTH_GUM_TYPE_KEY, TOOTH_STAGE_NUMBER_KEY } from "../constant/toothConstant";

/**
 * @type {GumDO[]}
 */
const gumDOListSingle = [];

const gumDOMapSingle = {};

/**
 * @param {GumDO} gumDO
 */
const addGumDO = (gumDO) => {
  gumDOListSingle.push(gumDO);
  const key = `${TOOTH_STAGE_NUMBER_KEY}:${gumDO.stageNumber}.${TOOTH_GUM_TYPE_KEY}:${gumDO.toothGumType}`;
  gumDOMapSingle[key] = gumDO;
};

const getGumDOList = () => {
  return gumDOListSingle;
};

const getGumDOByStageNumberAndToothGumType = (stageNumber, toothGumType) => {
  const key = `${TOOTH_STAGE_NUMBER_KEY}:${stageNumber}.${TOOTH_GUM_TYPE_KEY}:${toothGumType}`;
  return gumDOMapSingle[key];
};

export default {
  addGumDO,
  getGumDOList,
  getGumDOByStageNumberAndToothGumType,
};
